import { Stack, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import AddressComp from "../addressComp/AddressComp";
import { LoadingButton } from "@mui/lab";
import { ClientType, SettingsDetailsType } from "../../types/genericType";
import { updateSettingsDetails } from "../../services/settingsService";
import { editClient } from "../../services/clientService";
import CustomSnackbar from "../common/Snackbar/CustomSnackbar";

type CompanyProfilePropTypes = {
  settingsData: SettingsDetailsType;
  companyData: ClientType;
};

const CompanyProfile = (props: CompanyProfilePropTypes) => {
  const { settingsData, companyData } = props;
  const [onSuccess, setOnSuccess] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [companyName, setCompanyName] = useState(companyData.companyName ?? "");
  const [firstName, setfirstName] = useState(companyData.firstName ?? "");
  const [lastName, setlastName] = useState(companyData.lastName ?? "");
  const [taxNumber, settaxNumber] = useState(companyData.taxNumber ?? "");
  const [officePhone, setOfficePhone] = useState(companyData.officePhone ?? "");
  const [fax, setfax] = useState(companyData.fax ?? "");
  const [FirmEmail, setFirmEmail] = useState(companyData?.email ?? "");
  const [ManagementFirm, setManagementFirm] = useState(
    settingsData?.ManagementFirm ?? ""
  );
  const [ManagementRate, setManagementRate] = useState(
    settingsData?.ManagementRate ?? ""
  );
  const [address, setAddress] = useState({
    address: companyData?.address ?? "",
    apartment: companyData?.apartment ?? "",
    city: companyData?.city ?? "",
    state: companyData?.state ?? "",
    zip: companyData?.zip ?? "",
    country: companyData?.country ?? "",
  });
  const [isLoading, setIsLoading] = React.useState(false);
  const [updatedFields, setUpdatedFields] = useState({});

  const updateSettingsFields = async () => {
    setIsLoading(true);

    const updateField = async (field: string, value: any) => {
      try {
        await updateSettingsDetails(field, value);
      } catch (error) {
        console.error(`Error updating ${field}`, error);
      }
    };

    for (const [field, value] of Object.entries(updatedFields)) {
      await updateField(field, value);
    }
    setOnSuccess(true);
    setSnackbarMsg('Details updated successfully');
    setIsLoading(false);
    setUpdatedFields({});
  };

  useEffect(() => {
    setManagementRate(settingsData?.ManagementRate ?? "");
    setManagementFirm(settingsData?.ManagementFirm ?? "");
  }, [settingsData]);

  const saveChanges = async () => {
    updateSettingsFields();
    setIsLoading(true);
    const data: ClientType = {
      id: 1,
      companyName,
      email: FirmEmail,
      firstName,
      lastName,
      taxNumber,
      officePhone,
      mobile: companyData?.mobile !== "" ? companyData?.mobile ?? null : null,
      homePhone:
        companyData?.homePhone !== "" ? companyData?.homePhone ?? null : null,
      type: companyData?.type ?? "",
      fax,
      ...address,
    };
    editClient(data)
      .then(() => {
        setIsLoading(false);
        setOnSuccess(true);
        setSnackbarMsg("Details updated successfully");
      })
      .catch((err: any) => {
        console.log(err);
        setIsLoading(false);
        setOnSuccess(true);
        setSnackbarMsg("Error updating details ");
      });
  };

  useEffect(() => {
    setCompanyName(companyData.companyName ?? "");
    setfirstName(companyData.firstName ?? "");
    setlastName(companyData.lastName ?? "");
    settaxNumber(companyData.taxNumber ?? "");
    setOfficePhone(companyData.officePhone ?? "");
    setfax(companyData.fax ?? "");
    setFirmEmail(companyData?.email ?? "");
    setAddress({
      address: companyData?.address ?? "",
      apartment: companyData?.apartment ?? "",
      city: companyData?.city ?? "",
      state: companyData?.state ?? "",
      zip: companyData?.zip ?? "",
      country: companyData?.country ?? "",
    });
  }, [companyData]);

  return (
    <Stack spacing={3}>
      <TextField
        id="outlined-helperText"
        label="Company Name"
        size="small"
        fullWidth
        value={companyName}
        onChange={(event) => setCompanyName(event.target.value as string)}
      />
      <TextField
        id="outlined-helperText"
        label="Contact First Name"
        size="small"
        fullWidth
        value={firstName}
        onChange={(event) => setfirstName(event.target.value as string)}
      />
      <TextField
        id="outlined-helperText"
        label="Contact Last Name"
        size="small"
        fullWidth
        value={lastName}
        onChange={(event) => setlastName(event.target.value as string)}
      />
      <TextField
        id="outlined-helperText"
        label="Tax ID"
        size="small"
        fullWidth
        value={taxNumber}
        onChange={(event) => settaxNumber(event.target.value as string)}
      />
      <TextField
        id="outlined-helperText"
        label="Office Phone"
        size="small"
        fullWidth
        value={officePhone}
        onChange={(event) => setOfficePhone(event.target.value as string)}
      />
      <TextField
        id="outlined-helperText"
        label="FAX Phone"
        size="small"
        fullWidth
        value={fax}
        onChange={(event) => setfax(event.target.value as string)}
      />
      <TextField
        id="outlined-helperText"
        label="FirmEmail"
        size="small"
        fullWidth
        value={FirmEmail}
        onChange={(event) => {
          setFirmEmail(event.target.value as string);
        }}
      />
      <TextField
        id="outlined-helperText"
        label="Management Firm"
        size="small"
        fullWidth
        value={ManagementFirm}
        onChange={(event) => {
          setManagementFirm(event.target.value as string);
          setUpdatedFields({
            ...updatedFields,
            ManagementFirm: event.target.value as string,
          });
        }}
      />
      <TextField
        id="outlined-helperText"
        label="Mgmt Rate"
        size="small"
        fullWidth
        value={ManagementRate}
        onChange={(event) => {
          setManagementRate(event.target.value as string);
          setUpdatedFields({
            ...updatedFields,
            ManagementRate: event.target.value as string,
          });
        }}
      />
      <AddressComp address={address} setAddress={setAddress} />
      <LoadingButton
        variant="contained"
        data-testid="createTxnBtn"
        size="small"
        sx={{
          height: "36px",
          width: "186px",
          color: "#FFFFFF",
        }}
        onClick={saveChanges}
        loading={isLoading}
      >
        SAVE CHANGES
      </LoadingButton>
      <CustomSnackbar
        open={onSuccess}
        message={snackbarMsg}
        setOpen={setOnSuccess}
      />
    </Stack>
  );
};

export default CompanyProfile;
